import { defaultUIAccessLevels, generateKeyNamesByAccessLevel } from '@nu-art/permissions-shared';
export const defaultTooltipDelay = 200;
export const ActionKey_ReferencesUIDtoID = '_id override with UID';
export const ActionKey_ReferencesUIDtoNewUID = 'UID to new UID';
export const KMApplicationName = 'knowledge-manager';
export const DomainNamespace_HealthcareSpace = 'Healthcare Space';
export const DomainNamespace_HealthcareSpaceUI = 'Healthcare Space UI';
export const PermissionKey_HCSEdit = 'permission-key--hcs-edit';
export const Const__ProjectName_KnowledgeManager = 'Knowledge Manager';
export const HCSPermissionKeys = {
    edit: PermissionKey_HCSEdit
};
export const HCSUIPermissionKeys = generateKeyNamesByAccessLevel(DomainNamespace_HealthcareSpaceUI, defaultUIAccessLevels);
//# sourceMappingURL=consts.js.map